import type { User } from "@/types/api";

// Helpers to centralize user-type discrimination. The wire model exposes
// User.type as one of "discord" | "free" | "whop". "free" is the lead-magnet
// account; "whop" and "discord" are paid/authenticated members.
//
// Use these instead of inline `user?.type === "free"` checks so consumers
// have one place to update if the user-type taxonomy changes.

export function isFreeUser(user: User | null | undefined): boolean {
  return user?.type === "free";
}

export function isPaidUser(user: User | null | undefined): boolean {
  return user != null && user.type !== "free";
}
